/**
 * セキュアなcookieを必ず付与するインターセプター
 * document.cookie の setter をオーバーライドして、自動的に Secure, HttpOnly, SameSite フラグを追加
 */

export function initSecureCookieInterceptor() {
  const originalDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
  
  if (!originalDescriptor) return;

  Object.defineProperty(Document.prototype, 'cookie', {
    get: originalDescriptor.get,
    set: function(cookieString: string) {
      // 既にセキュアなcookieの場合はスキップ
      if (cookieString.includes('Secure')) {
        originalDescriptor.set!.call(this, cookieString);
        return;
      }

      // HTTPSプロトコルの場合のみSecureフラグを追加
      if (window.location.protocol === 'https:') {
        // Secure, HttpOnly, SameSite フラグを追加
        let secureCookie = cookieString;
        
        // パスが明示されていなければ追加
        if (!secureCookie.includes('path=') && !secureCookie.includes('Path=')) {
          secureCookie += '; path=/';
        }
        
        // Secureフラグを追加
        if (!secureCookie.includes('Secure')) {
          secureCookie += '; Secure';
        }
        
        // SameSiteを追加（既に設定されていなければ）
        if (!secureCookie.includes('SameSite')) {
          secureCookie += '; SameSite=Lax';
        }
        
        console.log('🔒 Secure cookie set:', cookieString.split(';')[0]);
        originalDescriptor.set!.call(this, secureCookie);
      } else {
        // HTTP環境ではそのまま設定（開発環境用）
        console.warn('⚠️ Non-secure cookie in HTTP environment:', cookieString.split(';')[0]);
        originalDescriptor.set!.call(this, cookieString);
      }
    },
    configurable: true,
  });

  console.log('✅ Secure cookie interceptor initialized');
}
